module.exports = {
	createLegend: function(chart) {
		chart.legend = new window.am4charts.Legend();
		chart.legend.labels.template.maxWidth = 250;
		chart.legend.labels.template.wrap = true;
		chart.legend.paddingBottom = 10;
		chart.legend.labels.template.paddingLeft = 5;
		if (chart.className !== 'PieChart') {
			chart.legend.parent = chart.bottomAxesContainer;
		}
		chart.legend.position = 'center';
	}
};
